import { render, staticRenderFns } from "./CaeIcrea.vue?vue&type=template&id=4038724f&"
import script from "./CaeIcrea.vue?vue&type=script&lang=js&"
export * from "./CaeIcrea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports